import { NavLink } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components/macro";
import { device } from "./device";

// IE11 - who doesn't hate it?
export const Wrapper = styled.div`
  margin: 0 auto;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  @media ${device.tablet} {
    display: -ms-grid;
    display: ${(props) => (props.fullWidth ? "block" : "grid")};

    -ms-grid-columns: 1fr 1fr;
    grid-template-columns: repeat(2, 1fr);

    -ms-grid-rows: 30px 30px 30px 45px 1fr;

    grid-template-rows: 30px 30px 30px 45px repeat(1, 1fr);
    grid-column-gap: 25px;
  }
`;

export const MapWrapper = styled.div`
  @media ${device.tablet} {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 5;

    // IE11
    -ms-grid-column: 1;
    -ms-grid-row: 5;
  }
`;

export const NavWrapper = styled.div`
  display: flex;

  @media ${device.tablet} {
    grid-column-start: 2;
    grid-row-start: 1;
    grid-row-end: 3;

    // IE11
    -ms-grid-column: 2;
    -ms-grid-row: 1;
  }
`;

export const MapKeyWrapper = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
  @media ${device.tablet} {
    padding-top: 0;
    padding-bottom: 0;

    grid-column-start: 1;
    grid-row-start: 2;
    grid-row-end: 3;

    // IE11
    -ms-grid-column: 1;
    -ms-grid-row: 3;
  }
`;

export const PageWrapper = styled.div`
  overflow: hidden;
  @media ${device.tablet} {
    grid-column-start: 2;
    grid-row-start: 4;
    grid-row-end: 6;

    // IE11
    -ms-grid-column: 2;
    -ms-grid-row: 4;
  }
`;

export const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Open Sans', sans-serif;
    padding:0;
    margin:0;
  }
  h1,h2,h3,h4,h5 { font-family: 'Open Sans', sans-serif } ;
}
`;

// Change Quarter
export const ActiveQuarterWrapper = styled.div`
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  @media ${device.tablet} {
    text-align: left;
    padding-top: 0;
    padding-bottom: 0;

    grid-column-start: 1;
    grid-row-start: 1;
    grid-row-end: 2;

    // IE11
    -ms-grid-column: 1;
    -ms-grid-row: 2;
  }
`;

export const ActiveQuarter = styled.span`
  color: #007961;
  font-weight: bold;
`;
const activeClassName = "is-active";
export const ChangeQuarterLink = styled(NavLink).attrs({
  activeClassName,
})`
  text-decoration: none;
  color: #008067;
  font-weight: bold;
  text-decoration: underline;
`;

export const Footer = styled.footer`
  padding-top: 20px;
`;

export const FooterHeading = styled.h3`
  padding: 0;
  margin: 0;
  font-size: 0.75rem;
  color: #3d434f;
  line-height: 1;
  padding-bottom: 20px;
  font-weight: bold;
  @media ${device.tablet} {
    font-size: 0.75rem;
  }
`;

export const FooterContent = styled.div`
  font-size: 0.5625rem;

  @media ${device.tablet} {
    font-size: 0.75rem;
  }
`;
